import { customRenderText, fixHtml, removeHtml } from '../custom-render-text';

/** Plain text from a Storyblok `title` block (`titleText` richtext, else legacy `title`). */
export const getTitleBlockPlainText = (block?: {
  titleText?: unknown;
  title?: string;
}): string | undefined => {
  if (!block) return;

  if (block.titleText) {
    const text = removeHtml(fixHtml(customRenderText(block.titleText))).trim();
    if (text) return text;
  }

  if (block.title) return block.title;
};
